module.exports = __webpack_public_path__ + "04_glasses_brown.a5c2a7da.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer4/04_glasses_brown.png
// module id = lhQE
// module chunks = 0